import { DataTypeName } from "@redotech/redo-flows-core-schema-common/type-system/data-types";
import {
  GenericDataType,
  removeGenericFromType,
} from "@redotech/redo-flows-core-schema-common/type-system/data-types/generic-types";

export enum InspectorKind {
  TEXT = "text",
  ENUM = "enum",
  TOKEN = "token",
  BOOLEAN = "boolean",
  NUMBER = "number",
  CHECKOUT_CONTEXT_PREDICATE = "checkoutContextPredicate",
}

/**
 * The inspector each data type is edited with, keyed by the underlying type so
 * every `Maybe`/`Multiple` decoration of it is handled too.
 */
export const inspectorKindByDataType: Record<
  DataTypeName,
  InspectorKind | null
> = {
  Text: InspectorKind.TEXT,
  Url: InspectorKind.TEXT,
  Enum: InspectorKind.ENUM,
  Token: InspectorKind.TOKEN,
  Boolean: InspectorKind.BOOLEAN,
  Number: InspectorKind.NUMBER,
  Email: null,
  Phone: null,
  Date: null,
  DateTime: null,
  Name: null,
  Metadata: null,
  Object: null,
  Customer: null,
  Product: null,
  "Trigger Product": null,
  "Line Item": null,
  Tracker: null,
  "Cart Context": InspectorKind.CHECKOUT_CONTEXT_PREDICATE,
  "Subscriptions Charge": null,
  "Trackable Summary": null,
  "Review Request": null,
  "Email Attachment": null,
  "Url To Qr Code": null,
  "Shopify Checkout": null,
  "Discount Applications": null,
  "Subscription Cart Line": null,
};

/** Renders, but merchants have no reason to match a condition against a link. */
const typesHiddenFromConditionStep: DataTypeName[] = ["Url"];

/** Whether the condition step can offer a field of this type as a variable. */
export function isConditionableDataType(dataType: GenericDataType): boolean {
  const baseType = removeGenericFromType(dataType);
  return (
    inspectorKindByDataType[baseType] !== null &&
    !typesHiddenFromConditionStep.includes(baseType)
  );
}
